<template>
    <div class="row">
        <!-- Header -->
        <div class="col-12 mb-4">
            <div class="d-flex align-items-center justify-content-between flex-wrap">
                <div class="d-flex align-items-center">
                    <button @click="back" class="btn btn-outline-secondary btn-icon-text py-2 px-3 mr-3">
                        <i class="mdi mdi-arrow-left mr-1"></i> {{ $t('common.back') }}
                    </button>
                    <div>
                        <h2 class="text-white font-weight-bold mb-1">{{ $t('quests.createNewQuest') }}</h2>
                        <p class="text-muted small mb-0">{{ $t('quests.subtitle') }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 grid-margin">
            <div class="card border border-secondary">
                <div class="card-body">
                    <!-- Quick Quest Presets -->
                    <div class="rounded mb-4 p-3 d-flex align-items-center justify-content-between flex-wrap gap-2" style="background: rgba(30, 41, 59, 0.4); border: 1px solid #27272a;">
                        <div class="d-flex align-items-center mb-2 mb-md-0">
                            <i class="mdi mdi-lightning-bolt text-warning font-weight-bold mr-2" style="font-size: 1.25rem;"></i>
                            <div>
                                <div class="text-white font-weight-bold small">{{ $currentLocale === 'id' ? 'Templat Misi Cepat' : 'Quick Task Presets' }}</div>
                                <div class="text-muted small">{{ $currentLocale === 'id' ? 'Klik templat siap pakai untuk mengisi formulir misi secara otomatis' : 'Click a ready-made template to auto-fill the task form' }}</div>
                            </div>
                        </div>
                        <div class="d-flex flex-wrap gap-2">
                            <button type="button" @click="applyQuestPreset('standup')" class="btn btn-xs btn-outline-warning mr-1 mb-1">
                                <i class="mdi mdi-clock-check-outline mr-1"></i> {{ $currentLocale === 'id' ? 'Rapat Harian (+5 Gold)' : 'Daily Standup (+5 Gold)' }}
                            </button>
                            <button type="button" @click="applyQuestPreset('ticket')" class="btn btn-xs btn-outline-info mr-1 mb-1">
                                <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i> {{ $currentLocale === 'id' ? 'Selesai Tiket (+20 Gold)' : 'Ticket Completion (+20 Gold)' }}
                            </button>
                            <button type="button" @click="applyQuestPreset('retro')" class="btn btn-xs btn-outline-success mr-1 mb-1">
                                <i class="mdi mdi-account-group-outline mr-1"></i> {{ $currentLocale === 'id' ? 'Retrospektif (+15 Gold)' : 'Retrospective (+15 Gold)' }}
                            </button>
                            <button type="button" @click="applyQuestPreset('mentoring')" class="btn btn-xs btn-outline-primary mb-1">
                                <i class="mdi mdi-school-outline mr-1"></i> {{ $currentLocale === 'id' ? 'Mentoring Tim (+25 Gold)' : 'Team Mentoring (+25 Gold)' }}
                            </button>
                        </div>
                    </div>

                    <form class="forms-sample" method="post" @submit.prevent="submitForm" enctype="multipart/form-data">
                        <div class="form-group row">
                            <div class="col-md-6 mb-3">
                                <label for="nameInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('quests.questName') }}</label>
                                <input id="nameInput" type="text" class="form-control" v-model="ruleStore.name" :placeholder="$currentLocale === 'id' ? 'Contoh: Selesaikan 5 Tiket Dukungan' : 'e.g. Resolve 5 Support Tickets'" required />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="typeInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('rulesForm.questType') }}</label>
                                <select class="form-control" id="typeInput" v-model="ruleStore.type">
                                    <option value="always_active">{{ $t('rulesForm.alwaysActive') }}</option>
                                    <option value="onetime">{{ $t('rulesForm.oneTime') }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-md-6 mb-3">
                                <div class="p-3 bg-dark rounded border border-secondary h-100">
                                    <label for="rewardInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('rulesForm.rewardType') }}</label>
                                    <select class="form-control mb-3" id="rewardInput" v-model="ruleStore.reward">
                                        <option value="gold">{{ $t('rulesForm.goldCoins') }}</option>
                                        <option value="non_gold">{{ $t('rulesForm.nonGoldPerk') }}</option>
                                    </select>
                                    <div v-if="ruleStore.reward === 'gold'">
                                        <div class="input-group">
                                            <input type="number" class="form-control" v-model="ruleStore.gold" min="0" placeholder="0" />
                                            <div class="input-group-append">
                                                <span class="input-group-text bg-dark border-secondary text-warning font-weight-bold">
                                                    <i class="mdi mdi-circle-multiple mr-1"></i> Gold
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <textarea v-else type="text" class="form-control" rows="2" v-model="ruleStore.non_gold" :placeholder="$currentLocale === 'id' ? 'Deskripsi hadiah non-gold' : 'Non-gold reward description'"></textarea>
                                </div>
                            </div>

                            <div class="col-md-6 mb-3">
                                <div class="p-3 bg-dark rounded border border-secondary h-100">
                                    <label for="repeatInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('rulesForm.frequency') }}</label>
                                    <select class="form-control mb-2" id="repeatInput" v-model="ruleStore.repeat_type">
                                        <option value="no_repeat">{{ $t('rulesForm.noRepeat') }}</option>
                                        <option value="daily">{{ $t('rulesForm.daily') }}</option>
                                        <option value="weekly">{{ $t('rulesForm.weekly') }}</option>
                                        <option value="monthly">{{ $t('rulesForm.monthly') }}</option>
                                    </select>
                                    <div v-if="ruleStore.repeat_type === 'daily'">
                                        <ul class="custom-list">
                                            <li v-for="(day, index) in ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']" :key="index">
                                                <input type="checkbox" class="form-check-input" :id="day" v-model="ruleStore.repeat_on_daily[day]" />
                                                <label class="form-check-label text-capitalize small text-white" :for="day">{{ formatDayLabel(day) }}</label>
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-if="ruleStore.repeat_type === 'weekly'">
                                        <ul class="custom-list">
                                            <li v-for="(day, index) in ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']" :key="index">
                                                <input type="radio" class="form-check-input" :name="'weekly-' + day" :value="index + 1" v-model="ruleStore.repeat_on_day" />
                                                <label class="form-check-label text-capitalize small text-white">{{ formatDayLabel(day) }}</label>
                                            </li>
                                        </ul>
                                    </div>
                                    <input v-if="ruleStore.repeat_type === 'monthly'" type="number" v-model="ruleStore.repeat_on_date" class="form-control mt-2" min="1" max="31" :placeholder="$currentLocale === 'id' ? 'Tanggal 1-31' : 'Day 1-31'" />
                                    <div class="mt-2" v-if="ruleStore.repeat_type !== 'no_repeat'">
                                        <label class="text-muted small">{{ $t('rulesForm.endsOn') }}</label>
                                        <input type="date" class="form-control" v-model="ruleStore.ends_on" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-md-6 mb-3">
                                <div class="p-3 bg-dark rounded border border-secondary h-100">
                                    <label class="d-flex align-items-center mb-2">
                                        <input type="checkbox" class="form-check-input mt-0 mr-2" v-model="ruleStore.contest" />
                                        <span class="form-check-label text-warning font-weight-bold">{{ $currentLocale === 'id' ? 'Acara / Kontes Berbatas Waktu' : 'Time-Limited Event / Contest' }}</span>
                                    </label>
                                    <div v-if="ruleStore.contest" class="row g-2 mt-2">
                                        <div class="col-6">
                                            <small class="text-muted d-block mb-1">{{ $currentLocale === 'id' ? 'Mulai' : 'Start Date' }}</small>
                                            <input type="date" class="form-control" v-model="ruleStore.start_date" />
                                        </div>
                                        <div class="col-6">
                                            <small class="text-muted d-block mb-1">{{ $currentLocale === 'id' ? 'Berakhir' : 'End Date' }}</small>
                                            <input type="date" class="form-control" v-model="ruleStore.end_date" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 mb-3">
                                <div class="p-3 bg-dark rounded border border-secondary h-100">
                                    <label for="assignedToInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('rulesForm.targetAssignees') }}</label>
                                    <select class="form-control" id="assignedToInput" v-model="ruleStore.assigned_to">
                                        <option value="all_player">{{ $t('rulesForm.allPlayers') }}</option>
                                        <option value="specific_player">{{ $t('rulesForm.specificPlayers') }}</option>
                                        <option value="specific_squad">{{ $t('rulesForm.specificSquads') }}</option>
                                    </select>
                                    <multiselect class="mt-3" v-if="ruleStore.assigned_to === 'specific_player'"
                                        v-model="ruleStore.assigned_user_id" :options="assignedUserId" :multiple="true"
                                        :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                                        :placeholder="$currentLocale === 'id' ? 'Pilih anggota tim' : 'Select team members'" label="name" track-by="id">
                                    </multiselect>
                                    <multiselect class="mt-3" v-if="ruleStore.assigned_to === 'specific_squad'"
                                        v-model="ruleStore.assigned_division_id" :options="assignedDivisionId"
                                        :multiple="true" :close-on-select="false" :clear-on-select="false"
                                        :preserve-search="true" :placeholder="$currentLocale === 'id' ? 'Pilih tim / divisi' : 'Select divisions'" label="name" track-by="id">
                                    </multiselect>
                                </div>
                            </div>
                        </div>

                        <div class="form-group mb-4">
                            <label for="descriptionInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('rulesForm.description') }}</label>
                            <textarea class="form-control" id="descriptionInput" rows="3" v-model="ruleStore.description" :placeholder="$t('rulesForm.descPlaceholder')"></textarea>
                        </div>

                        <!-- Self-Checking Checklist Section for Players -->
                        <div class="form-group mb-4">
                            <div class="p-3 bg-dark rounded border border-secondary">
                                <div class="d-flex align-items-center justify-content-between mb-2 flex-wrap">
                                    <div>
                                        <label class="text-muted small text-uppercase font-weight-bold mb-0">
                                            <i class="mdi mdi-checkbox-marked-circle-outline text-success mr-1"></i>
                                            {{ $currentLocale === 'id' ? 'Daftar Periksa Mandiri / Kriteria SOP' : 'Self-Checking QA / SOP Criteria Checklist' }}
                                        </label>
                                        <p class="text-muted small mb-0">{{ $currentLocale === 'id' ? 'Anggota tim dapat mencentang poin-poin ini saat mengerjakan tugas untuk memastikan hasil kerja sesuai standar.' : 'Team members can check these items while completing the task to ensure quality standards are met.' }}</p>
                                    </div>
                                    <div class="d-flex gap-1 mt-2 mt-md-0">
                                        <button type="button" @click="addPreset('standar')" class="btn btn-xs btn-outline-info mr-1">
                                            {{ $currentLocale === 'id' ? '+ SOP Standar' : '+ Standard SOP' }}
                                        </button>
                                        <button type="button" @click="addPreset('dev')" class="btn btn-xs btn-outline-warning mr-1">
                                            {{ $currentLocale === 'id' ? '+ Perbaikan Bug / Dev' : '+ Bug Fix / Dev' }}
                                        </button>
                                        <button type="button" @click="addPreset('creative')" class="btn btn-xs btn-outline-success">
                                            {{ $currentLocale === 'id' ? '+ Desain / Konten' : '+ Design / Content' }}
                                        </button>
                                    </div>
                                </div>

                                <div class="input-group mb-3">
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        v-model="newChecklistItem" 
                                        @keyup.enter.prevent="addChecklistItem" 
                                        :placeholder="$currentLocale === 'id' ? 'Tulis kriteria verifikasi... (tekan Enter atau klik Tambah Poin)' : 'Enter verification criteria... (press Enter or click Add Item)'"
                                    />
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-success font-weight-bold" @click="addChecklistItem">
                                            <i class="mdi mdi-plus"></i> {{ $currentLocale === 'id' ? 'Tambah Poin' : 'Add Item' }}
                                        </button>
                                    </div>
                                </div>

                                <div v-if="ruleStore.checklist && ruleStore.checklist.length > 0" class="d-flex flex-column gap-2">
                                    <div 
                                        v-for="(item, idx) in ruleStore.checklist" 
                                        :key="idx" 
                                        class="d-flex align-items-center justify-content-between p-2 rounded mb-2"
                                        style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1);"
                                    >
                                        <div class="d-flex align-items-center flex-grow-1 mr-2">
                                            <span class="badge badge-secondary mr-2">{{ idx + 1 }}</span>
                                            <input 
                                                type="text" 
                                                class="form-control form-control-sm bg-transparent border-0 text-white" 
                                                v-model="ruleStore.checklist[idx]"
                                            />
                                        </div>
                                        <button type="button" class="btn btn-link text-danger p-0" @click="removeChecklistItem(idx)">
                                            <i class="mdi mdi-delete-outline f-18"></i>
                                        </button>
                                    </div>
                                </div>
                                <div v-else class="text-center py-3 text-muted small border border-dashed rounded" style="border-color: rgba(255,255,255,0.1) !important;">
                                    {{ $currentLocale === 'id' ? 'Belum ada kriteria daftar periksa. Tambahkan poin secara manual atau klik templat di atas agar anggota tim dapat memeriksa mandiri sebelum mengirim bukti.' : 'No checklist criteria yet. Add items manually or click a preset above so team members can self-check before submitting proof.' }}
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-end gap-2">
                            <button type="button" @click="back" class="btn btn-outline-secondary px-4 py-2 mr-2" :disabled="loading">
                                {{ $t('common.back') }}
                            </button>
                            <button type="submit" class="btn btn-primary px-4 py-2 font-weight-bold" :disabled="loading">
                                <span class="spinner-border spinner-border-sm mr-1" v-if="loading" role="status"></span>
                                <i class="mdi mdi-check-all mr-1" v-else></i>
                                {{ $t('common.submit') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import "dropify";
import { storeReward } from "../../services/rewardService";
import Swal from 'sweetalert2';
import { getUser, getDivision } from '../../services/rewardService';
import Multiselect from 'vue-multiselect';

export default {
    components: {
        Multiselect
    },
    data: () => ({
        ruleStore: {
            name: '',
            type: 'always_active',
            reward: 'gold',
            gold: 0,
            non_gold: '',
            repeat_type: 'no_repeat',
            repeat_on_daily: {
                sunday: false,
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false
            },
            repeat_on_weekly: '',
            repeat_on_monthly: '',
            repeat_on_date: '',
            ends_on: '',
            description: '',
            contest: false,
            start_date: '',
            end_date: '',
            date_period: '',
            assigned_to: 'all_player',
            repeat_on_day: '',
            assigned_user_id: [],
            assigned_division_id: [],
            checklist: [],
        },
        newChecklistItem: '',
        loading: false,
        isApplyingPreset: false,
        assignedUserId: [],
        assignedDivisionId: [],
    }),
    watch: {
        'ruleStore.type': function (val) {
            if (this.isApplyingPreset) return;
            if (val === 'onetime') {
                this.ruleStore.repeat_type = 'no_repeat';
            }
        },
        'ruleStore.repeat_type': function (val) {
            if (val && val !== 'no_repeat') {
                this.ruleStore.type = 'always_active';
            }
            if (this.isApplyingPreset) return;
            this.ruleStore.repeat_on_daily = {
                sunday: false,
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false
            };
            this.ruleStore.repeat_on_weekly = '';
            this.ruleStore.repeat_on_monthly = '';
            this.ruleStore.repeat_on_date = '';
            this.ruleStore.ends_on = '';
            this.ruleStore.type = this.ruleStore.repeat_type !== 'no_repeat' ? 'always_active' : 'onetime';
        },
        'ruleStore.assigned_to': function (val) {
            if (val === 'all_player') {
                this.ruleStore.assigned_user_id = [];
                this.ruleStore.assigned_division_id = [];
                this.assignedUserId = [];
                this.assignedDivisionId = [];
            } else if (val === 'specific_player' || val === 'player') {
                this.ruleStore.assigned_division_id = [];
                this.assignedDivisionId = [];
            } else if (val === 'specific_squad' || val === 'division') {
                this.ruleStore.assigned_user_id = [];
                this.assignedUserId = [];
            }
            this.fetchAssignedData();
        },
        'ruleStore.reward': function (val) {
            if (this.isApplyingPreset) return;
            if (val === 'gold') {
                this.ruleStore.non_gold = '';
            } else if (val === 'non_gold') {
                this.ruleStore.gold = 0;
            }
        }
    },
    computed: {
        repeatOnDaily() {
            return this.ruleStore.repeat_on_daily;
        },
        repeatOnWeekly() {
            return this.ruleStore.repeat_on_weekly;
        },
        repeatOnMonthly() {
            return this.ruleStore.repeat_on_monthly;
        }
    },
    methods: {
        formatDayLabel(day) {
            const idDays = {
                monday: 'Senin',
                tuesday: 'Selasa',
                wednesday: 'Rabu',
                thursday: 'Kamis',
                friday: 'Jumat',
                saturday: 'Sabtu',
                sunday: 'Minggu',
            };
            if (this.$currentLocale === 'id') {
                return idDays[day] || day;
            }
            return day.charAt(0).toUpperCase() + day.slice(1);
        },
        addChecklistItem() {
            if (!this.newChecklistItem || !this.newChecklistItem.trim()) return;
            if (!this.ruleStore.checklist) this.ruleStore.checklist = [];
            this.ruleStore.checklist.push(this.newChecklistItem.trim());
            this.newChecklistItem = '';
        },
        removeChecklistItem(idx) {
            this.ruleStore.checklist.splice(idx, 1);
        },
        addPreset(type) {
            if (!this.ruleStore.checklist) this.ruleStore.checklist = [];
            const isId = this.$currentLocale === 'id';
            const presets = isId ? {
                standar: [
                    'Pekerjaan telah diuji & diverifikasi mandiri',
                    'Tangkapan layar bukti hasil kerja jelas dan terbaca',
                    'Sesuai dengan SOP dan standar kualitas tim'
                ],
                dev: [
                    'Kode cabang sudah diunggah & pemeriksaan otomatis lulus',
                    'Tangkapan layar reproduksi masalah dan hasil perbaikan',
                    'Tautan repositori disematkan di kolom tautan'
                ],
                creative: [
                    'Aset desain sudah diekspor sesuai format & resolusi',
                    'Tautan berkas desain memiliki akses lihat untuk tim',
                    'Pratinjau implementasi terlampir sebagai bukti'
                ]
            } : {
                standar: [
                    'Work has been self-tested and verified',
                    'Proof screenshot is clear and legible',
                    'Complies with team SOP and quality standards'
                ],
                dev: [
                    'Code branch pushed and CI/CD checks passed',
                    'Issue reproduction vs fix result screenshot attached',
                    'PR / Commit link included in the link field'
                ],
                creative: [
                    'Design assets exported in required format & resolution',
                    'Figma / Canva file link has view access for the team',
                    'Implementation mockup attached as proof'
                ]
            };
            const items = presets[type] || [];
            items.forEach(it => {
                if (!this.ruleStore.checklist.includes(it)) {
                    this.ruleStore.checklist.push(it);
                }
            });
        },
        async fetchAssignedData() {
            if (this.ruleStore.assigned_to === 'specific_player') {
                await getUser().then(response => {
                    this.assignedUserId = response.data;
                });
                this.ruleStore.assigned_division_id = [];
            } else if (this.ruleStore.assigned_to === 'specific_squad') {
                await getDivision().then(response => {
                    this.assignedDivisionId = response.data;
                });
                this.ruleStore.assigned_user_id = [];
            }
        },
        back() {
            this.$router.go(-1);
        },
        applyQuestPreset(type) {
            const isId = this.$currentLocale === 'id';
            const presets = isId ? {
                standup: {
                    name: 'Hadir Tepat Waktu Rapat Koordinasi Harian',
                    type: 'always_active',
                    reward: 'gold',
                    gold: 5,
                    non_gold: '',
                    repeat_type: 'daily',
                    repeat_on_daily: {
                        monday: true,
                        tuesday: true,
                        wednesday: true,
                        thursday: true,
                        friday: true,
                        saturday: false,
                        sunday: false
                    },
                    description: 'Hadir dan aktif memberikan laporan perkembangan, kendala, dan rencana harian pada sesi rapat koordinasi.',
                    checklist: [
                        'Hadir tepat waktu sebelum sesi rapat dimulai',
                        'Menyampaikan perkembangan pekerjaan kemarin & rencana hari ini',
                        'Mengemukakan kendala teknis bila ada'
                    ],
                },
                ticket: {
                    name: 'Penyelesaian Tiket & Tugas Mingguan',
                    type: 'always_active',
                    reward: 'gold',
                    gold: 20,
                    non_gold: '',
                    repeat_type: 'no_repeat',
                    description: 'Menyelesaikan tiket atau tugas dengan kriteria penerimaan terpenuhi dan kode terunggah rapi.',
                    checklist: [
                        'Kriteria penerimaan tugas terpenuhi secara lengkap',
                        'Pengujian mandiri lulus tanpa kendala',
                        'Lampirkan tautan repositori atau bukti pengerjaan'
                    ],
                },
                retro: {
                    name: 'Partisipasi Aktif Evaluasi Retrospektif',
                    type: 'always_active',
                    reward: 'gold',
                    gold: 15,
                    non_gold: '',
                    repeat_type: 'weekly',
                    repeat_on_day: 5,
                    description: 'Memberikan masukan konstruktif dan usulan perbaikan untuk tim pada sesi evaluasi mingguan.',
                    checklist: [
                        'Menuliskan poin evaluasi tim dan rencana tindak lanjut',
                        'Mengikuti diskusi retrospektif hingga selesai'
                    ],
                },
                mentoring: {
                    name: 'Bimbingan & Tinjauan Kerja Rekan Tim',
                    type: 'always_active',
                    reward: 'gold',
                    gold: 25,
                    non_gold: '',
                    repeat_type: 'no_repeat',
                    description: 'Membantu orientasi rekan tim baru atau memberikan tinjauan mendalam pada pekerjaan rekan tim.',
                    checklist: [
                        'Memberikan masukan tinjauan yang konstruktif dan membangun',
                        'Membantu menyelesaikan kendala teknis rekan tim'
                    ],
                }
            } : {
                standup: {
                    name: 'On-Time Daily Standup Attendance',
                    type: 'always_active',
                    reward: 'gold',
                    gold: 5,
                    non_gold: '',
                    repeat_type: 'daily',
                    repeat_on_daily: {
                        monday: true,
                        tuesday: true,
                        wednesday: true,
                        thursday: true,
                        friday: true,
                        saturday: false,
                        sunday: false
                    },
                    description: 'Attend and actively share progress updates, blockers, and daily plans during the standup session.',
                    checklist: [
                        'Join on time before the standup session starts',
                        'Share yesterday progress and today action plan',
                        'Highlight any technical blockers if applicable'
                    ],
                },
                ticket: {
                    name: 'Sprint Ticket & Task Completion',
                    type: 'always_active',
                    reward: 'gold',
                    gold: 20,
                    non_gold: '',
                    repeat_type: 'no_repeat',
                    description: 'Complete assigned sprint ticket or task with all acceptance criteria met and clean code pushed.',
                    checklist: [
                        'All task acceptance criteria are fully met',
                        'Self-testing and sanity checks pass without errors',
                        'Attach Pull Request link or completion proof'
                    ],
                },
                retro: {
                    name: 'Active Sprint Retrospective Participation',
                    type: 'always_active',
                    reward: 'gold',
                    gold: 15,
                    non_gold: '',
                    repeat_type: 'weekly',
                    repeat_on_day: 5,
                    description: 'Provide constructive feedback and improvement insights for the team during the weekly retrospective.',
                    checklist: [
                        'Document team evaluation points (What Went Well & Action Items)',
                        'Participate in the retrospective discussion until completion'
                    ],
                },
                mentoring: {
                    name: 'Team Mentoring & Peer Review',
                    type: 'always_active',
                    reward: 'gold',
                    gold: 25,
                    non_gold: '',
                    repeat_type: 'no_repeat',
                    description: 'Assist with new teammate onboarding or provide thorough peer review on a teammate deliverable.',
                    checklist: [
                        'Provide constructive and actionable review feedback',
                        'Help resolve technical blockers for a teammate'
                    ],
                }
            };

            const p = presets[type];
            if (p) {
                this.isApplyingPreset = true;
                this.ruleStore.name = p.name;
                this.ruleStore.type = p.type;
                this.ruleStore.reward = p.reward;
                this.ruleStore.gold = p.gold;
                this.ruleStore.non_gold = p.non_gold;
                this.ruleStore.repeat_type = p.repeat_type;
                if (p.repeat_on_daily) {
                    this.ruleStore.repeat_on_daily = { ...p.repeat_on_daily };
                }
                if (p.repeat_on_day) {
                    this.ruleStore.repeat_on_day = p.repeat_on_day;
                }
                this.ruleStore.description = p.description;
                this.ruleStore.checklist = [...p.checklist];
                this.$nextTick(() => {
                    this.isApplyingPreset = false;
                });
            }
        },
        async submitForm() {
            if (this.ruleStore.repeat_type === 'weekly' && !this.ruleStore.repeat_on_day) {
                Swal.fire({
                    icon: 'error',
                    title: this.$t('common.error'),
                    text: this.$currentLocale === 'id' ? 'Pilih hari untuk pengulangan mingguan.' : 'Please select a day for weekly repeat.',
                });
                return;
            }

            this.loading = true;
            try {
                // Map to extract only the IDs safely
                const payload = {
                    ...this.ruleStore,
                    assigned_user_id: (this.ruleStore.assigned_user_id || []).map(user => (user && user.id) ? user.id : user),
                    assigned_division_id: (this.ruleStore.assigned_division_id || []).map(division => (division && division.id) ? division.id : division),
                };

                await storeReward(payload);
                Swal.fire({
                    icon: 'success',
                    title: this.$t('common.success'),
                    text: this.$t('rulesForm.savedSuccess'),
                });

                this.$router.push('/rules/rewards');
            } catch (error) {
                const errMsg = error.response?.data?.message || (this.$currentLocale === 'id' ? 'Gagal menyimpan misi.' : 'Failed to save task.');
                Swal.fire({
                    icon: 'error',
                    title: this.$t('common.error'),
                    text: errMsg,
                });
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>
ul.custom-list {
    list-style-type: none;
    padding: 0;
}

ul.custom-list li {
    margin: 20px 0;
    display: flex;
    align-items: center;
}

ul.custom-list li input[type="checkbox"],
ul.custom-list li input[type="radio"] {
    margin-top: 0px;
    margin-left: 10px;
    margin-right: 10px;
    transform: scale(1);
}

ul.custom-list li span {
    font-size: 1.2em;
}

.grouping {
    background-color: #282e3e;
    padding: 10px;
    border-radius: 10px;
}
</style>
